import { useEffect, useRef, useState } from 'react'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import { Icon } from 'assets/index'
import useStorage from 'hooks/useStorage'
import getTotalValueFromColumn from 'helper/getTotalValueFromColumn'
import { ColumnType } from '../../type'
import { ColumnContainer, Header } from './style'
import { ItemList } from '../ItemList/ItemList'
import { useBoard } from '../../data/BoardProvider'

type IColumnProps = {
  onTrash?: ((id: string) => void) | false
  columnsWithTrash?: number[]
  column: ColumnType
  investCard: boolean
  handleClick?: () => void
  noSpecialist?: boolean
  notDraggable?: boolean
  isEnterprise?: boolean
  height?: string
}

export const Column = ({
  column,
  onTrash,
  investCard,
  handleClick,
  noSpecialist,
  notDraggable,
  isEnterprise,
  columnsWithTrash,
  height,
}: IColumnProps) => {
  const { id, cardList } = column
  const ref = useRef<HTMLDivElement | null>(null)
  const { moveCard } = useBoard()
  const [isExpanded, setIsExpanded] = useState(false)
  const [pallete] = useStorage('pallete')

  useEffect(() => {
    const element = ref.current
    if (!element) return
    // Se o elemento não estiver disponível, sai da função

    const dropConfig = {
      element,
      // Configuração do comportamento de drop (soltar elementos na coluna)
      onDrop: ({ source }: any) => {
        if (source?.data?.id) {
          // Certifique-se de chamar a função moveCard corretamente
          moveCard(source.data.id, id)
        }
      },
    }

    // Registra o elemento como um alvo de drop
    const cleanupDrop = dropTargetForElements(dropConfig)

    return () => {
      cleanupDrop()
    }
  }, [id, moveCard])

  return (
    <ColumnContainer
      ref={ref}
      className="column-container"
      investCard={investCard}
      data-testid={`column-${column.name}`}
      height={height}
    >
      <Header
        isExpanded={isExpanded}
        background={column?.color ? pallete[column.color] : undefined}
        investCard={investCard}
      >
        <div className="column-header-content">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img
              className="icon-kanban filter-icon"
              src={Icon(
                column?.icon === 'default.png'
                  ? 'clock.svg'
                  : column.icon.replace('png', 'svg')
              )}
              alt="card icon"
            />

            <span className="column-name">{column?.name}:</span>
            <span className="column-name">{column.cardList?.length}</span>
          </div>

          {column.isExpandable && (
            <button
              className="expand-kanban"
              type="button"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <img
                className="expand-kanban filter-icon"
                src={Icon('chevron_down.svg')}
                alt="expand icon"
              />
            </button>
          )}
        </div>
        {column.isExpandable && (
          <div className="totalValue">
            R${' '}
            {getTotalValueFromColumn(column).toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}
          </div>
        )}
      </Header>

      <ItemList
        handleClick={handleClick}
        cardList={cardList}
        column={column}
        onTrash={onTrash}
        columnsWithTrash={columnsWithTrash}
        investCard={investCard}
        noSpecialist={noSpecialist}
        notDraggable={notDraggable}
        isEnterprise={isEnterprise}
      />
    </ColumnContainer>
  )
}
